import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { TicketBatch } from '../entities/ticket-batch';
import { TicketBatchTicket } from '../entities/ticket-batch-ticket';

export class TicketBatchTicketRequest extends BaseRequest{

	constructor(userInfo : UserInfo){    
		super(userInfo)
	}
	
	ticketBatchTicket : TicketBatchTicket;
}
